export default __webpack_public_path__ + "063c6ce.png";